import { GlobalContext } from "../../hooks/globalContext";
import { SetStateAction, useContext, useEffect, useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { Stack, StackItem } from "@fluentui/react";
import { MenuList, MenuItem, Body1Strong, Tooltip, FluentProvider } from "@fluentui/react-components";
import { ChevronDoubleRight16Filled, AppFolder20Regular, DesktopFlow20Regular, DesktopTower20Regular, DocumentSearch20Regular, Settings20Regular, WrenchScrewdriver20Regular, ChevronDoubleLeft16Filled } from "@fluentui/react-icons";
import { IconColor, lightTheme, parentHome, primaryIcon, tenantBorder } from '../../styles/customStyles';
import apiCall from "../../utility/api";

type updateMenuType = SetStateAction<iMenuItem[]>;

interface iSiderbar {
    leftOpen: boolean,
    setLeftOpen: (arg0: boolean) => void;
};

interface iMenuItem {
    name: string;
    title: string;
    icon: JSX.Element;
    path: string;
};

interface iCreateMenu {
    title: any;
    icon: any;
    path: any;
};

const { investigate, authPages, navs, permits, roles } = {
    investigate: ["/investigate/analytics"],
    authPages: ["/", "/signin", "/auth/reset-password", "/signup", "/auth/change-password", "/home", "/verifyotp", "/unauthorised", "/restricted"],
    navs: ["/automate/automation/all_automations", "/automate/automation/configuration", "/automate/automation/selfhelp", "/automate/automation/autoheal", "/automate/automation/automationschedule", "/automate/automation/usersurvey", "/automate/automation/alerts", "/automate/automation/activitylog", "/automate/automation/compliancepolices", "/automate/automation/compliancepolicy", "/automate/apps/appmonitored", "/automate/apps/appinstallation", "/automate/apps/appuninstallprofile", "/automate/apps/appprotectionpolicies", "/automate/security/compliancepolicy", "/automate/security/data_collection", "/automate/security/activitylog", "/automate/apps/activitylog", "/automate/patch/patch", "/investigate/analytics"],
    permits: ["appInstall", "appUnInstall", "discoverApps", "appLog" /*, "appStatus"*/],
    roles: ["admin", "Nanoheal-admin"]
};

export const Sidebar = (props: iSiderbar) => {
    const { leftOpen } = props;
    const navigate = useNavigate();
    const location = useLocation();
    const contextValue: any = useContext(GlobalContext);
    const role = sessionStorage.getItem('role');

    const [appPermissionsDetails, setAppPermissionsDetails] = useState<string[]>([]);
    const [permissionsDetails, setPermissionsDetails] = useState<string[]>([]);
    const [filteredManageMenu, setFilteredManageMenu] = useState<iMenuItem[]>([]);
    const [filteredAutomateMenu, setFilteredAutomateMenu] = useState<iMenuItem[]>([]);
    const [sidebarVisibility, investigatePage, navigationIcons] = [authPages, investigate, navs].map(arr => arr.includes(location.pathname));

    sessionStorage.setItem("leftOpenMenu", `${leftOpen}`);

    useEffect(() => {
        const fetchPermissions = async () => {
            // const props: any = { setPermissionsDetails: setPermissionsDetails, role: role } // await getPermissionListSchmea(props);
            try { // const role: any = props.role;
                let { data, status } = await apiCall('/administration/getPermissionSchema', { role: role });
                if (status === "success" && data?.length > 0) {
                    const result = JSON.parse(data[0]?.permissionSchema);
                    setPermissionsDetails(Object.keys(result));
                    setAppPermissionsDetails(Object.keys(result?.apps));
                    console.log("Permission: ", result)
                }
            } catch (error) {
                console.error("An unexpected error occurred at getPermissionList: ", error);
            }
        };
        role && fetchPermissions();
    }, [role]);

    const manageItems: iMenuItem[] = [
        { name: "devices", title: "Devices", icon: <DesktopTower20Regular {...primaryIcon} />, path: "/manage/devices/overview" },
        { name: "apps", title: "Apps", icon: <AppFolder20Regular {...primaryIcon} />, path: "/manage/apps/discoveredapps" },
        { name: "patchmanagement", title: "Patch Management", icon: <AppFolder20Regular {...primaryIcon} />, path: "/manage/patchmanagement/patchdetection" },
        { name: "troubleshoot", title: "Troubleshoot", icon: <WrenchScrewdriver20Regular {...primaryIcon} />, path: "manage/troubleshoot/alert" },
        { name: "search", title: "Search", icon: <DocumentSearch20Regular {...primaryIcon} />, path: "/manage/search/asset" },
        { name: "administrationTitle", title: "Administration", icon: <Settings20Regular {...primaryIcon} />, path: "manage/administration/role" },
        // { name: "users", title: "Users", icon: <People20Regular {...primaryIcon} />, path: "/manage/user/role" }
    ];

    const automateItems: iMenuItem[] = [
        { name: "automation", title: "Automation", icon: <DesktopFlow20Regular {...primaryIcon} />, path: "/automate/automation/all_automations" },
        { name: "apps", title: "Apps", icon: <AppFolder20Regular {...primaryIcon} />, path: "/automate/apps/appmonitored" },
        { name: "security", title: "Security", icon: <AppFolder20Regular {...primaryIcon} />, path: "/automate/security/compliancepolicy" },
        // { name: "patch", title: "Patch", icon: <Patch20Regular {...primaryIcon} />, path: "/automate/patch/patch" }
    ];

    // useEffect(() => {
    //     const updateMenu = (manage: updateMenuType, automate: updateMenuType) => {
    //         setFilteredManageMenu(manage);
    //         setFilteredAutomateMenu(automate);
    //     };
    //     if (roles.includes(role)) { updateMenu(manageItems, automateItems) }
    //     else {
    //         // console.log("Checking permissions details: ", permissionsDetails);
    //         if (!permits?.some(appPermissionsDetails?.includes)) { manageItems.filter(({ name }) => name !== 'apps') }
    //         updateMenu(
    //             manageItems?.filter(({ name }) => permissionsDetails?.includes(name)),
    //             automateItems?.filter(({ name }) => permissionsDetails?.includes(name))
    //         )
    //     }
    // }, [permissionsDetails]);

    useEffect(() => {
        const updateMenu = (manage: updateMenuType, automate: updateMenuType) => {
            setFilteredManageMenu(manage);
            setFilteredAutomateMenu(automate);
        };

        if (roles.includes(role)) {
            updateMenu(manageItems, automateItems);
        } else {
            // Check if any permit exists in appPermissionsDetails
            const hasPermit = permits?.some(p => appPermissionsDetails?.includes(p));

            let updatedManageItems = manageItems;
            if (!hasPermit) {
                updatedManageItems = manageItems.filter(({ name }) => name !== 'apps');
            }

            updateMenu(
                updatedManageItems.filter(({ name }) => permissionsDetails?.includes(name)),
                automateItems.filter(({ name }) => permissionsDetails?.includes(name))
            );
        }
    }, [permissionsDetails]);


    const isInModule = (path: string) => {
        // Check if current location pathname starts with the module path, this will match any subpath within the module
        return location.pathname.startsWith(path.split('/').slice(0, 3).join('/'));
    };

    const getSidebarBackgroundColor = () => {
        const themechange = document.getElementById("themes");
        themechange.style.backgroundColor = "hsl(102.5,85.71%,94.51%)"
        if (navigationIcons) return themechange.style.backgroundColor = "hsl(102.5,85.71%,94.51%)"
        else if (investigatePage) return themechange.style.backgroundColor = "hsl(33.75,42.11%,92.55%)"; // Investigate
        else return themechange.style.backgroundColor = "hsl(51.43,87.5%,93.73%)"; // Manage
    };

    const menuOpen = (title: string, icon: JSX.Element, path: string) => {
        const items = <MenuItem icon={icon} onClick={() => navigate(path)}> {title} </MenuItem>;
        return (isInModule(path)) ? <FluentProvider theme={lightTheme}> {items} </FluentProvider> : items;
    };

    const menuClose = (icon: JSX.Element, path: string, tooltipContent: string) => {
        const items = (
            <Tooltip content={tooltipContent} withArrow appearance="inverted" positioning="after" relationship="label">
                <MenuItem icon={icon} onClick={() => navigate(path)} />
            </Tooltip>
        );
        return (isInModule(path)) ? <FluentProvider theme={lightTheme}> {items} </FluentProvider> : items;
    };

    const createMenuOpen = (menu: iCreateMenu[]) => menu.map(({ title, icon, path }) => menuOpen(title, icon, path));
    const createMenuLClose = (menu: iCreateMenu[]) => menu.map(({ title, icon, path }) => menuClose(icon, path, title));

    const openMenu = () => {
        return (!navigationIcons)
            ? createMenuOpen(filteredManageMenu)
            : (!investigatePage)
                ? createMenuOpen(filteredAutomateMenu)
                : menuOpen("Analytics", <AppFolder20Regular {...primaryIcon} />, "/investigate/analytics")
    };

    const closeMenu = () => {
        return (!navigationIcons)
            ? createMenuLClose(filteredManageMenu)
            : (!investigatePage)
                ? createMenuLClose(filteredAutomateMenu)
                : menuClose(<AppFolder20Regular {...primaryIcon} />, "/investigate/analytics", "Analytics")
    };

    const openedMenu = () => (
        <MenuList style={{ width: '190px', gap: "0px" }}>
            <MenuItem style={tenantBorder}>
                <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 5 }} horizontalAlign="space-between" onClick={() => props.setLeftOpen(!leftOpen)}>
                    <Stack horizontalAlign="start"><Body1Strong> {contextValue.tenantName} </Body1Strong></Stack>
                    <Stack horizontalAlign="end">
                        <Tooltip withArrow positioning="below" content="Hide" relationship="label">
                            <ChevronDoubleLeft16Filled {...IconColor} />
                        </Tooltip>
                    </Stack>
                </Stack>
            </MenuItem>
            {openMenu()}
        </MenuList>
    );

    const closedMenu = () => (
        <MenuList>
            <MenuItem>
                <StackItem align="start">
                    <Tooltip withArrow positioning="below" content="Show" relationship="label">
                        <ChevronDoubleRight16Filled {...IconColor} onClick={() => props.setLeftOpen(!leftOpen)} />
                    </Tooltip>
                </StackItem>
            </MenuItem>
            {closeMenu()}
        </MenuList>
    );

    const sidebarData = () => !sidebarVisibility && <Stack style={parentHome}> {leftOpen ? openedMenu() : closedMenu()} </Stack>;
    const store = localStorage.getItem("LogedInFrom");

    return ((store !== null && store !== undefined && JSON.parse(store)?.platform === "ServiceNow") || contextValue?.logedInFrom?.platform === "ServiceNow")
        ? null
        : sidebarData();
};

// CURRENTLY NOT IN USE
// const getPermissionList = async () => {
//     try {
//         const { data, loading } = await client.query({
//             query: GET_PERMISSION_LIST_SCHEMA,
//             variables: { role },
//             fetchPolicy: 'network-only'
//         });
//         if (!loading && data) {
//             const result = JSON.parse(data?.supertokens_roles[0]?.permissionSchema);
//             setPermissionsDetails(Object.keys(result));
//             console.log("Permission: ",result)
//         }
//     } catch (error) {
//         console.error("An unexpected error occurred at getPermissionList: ", error);
//     }
// };
